<template>
  <div class="main" id="staging_m">
    <!-- <el-backtop target=".aaa"></el-backtop> -->

    <div class="sidebar-all">

      <img class="logo" src="@/assets/img/Tron.png" alt="">
      <div class="userItem">


        <el-dropdown style="margin-right: 6vw;" v-if="checkUserLogin()" trigger="hover" @command="changeBtn"
          class="userBox">

          <p><img style="width: 5vw;margin-right: 2vw;" src="@/assets/img/login.png" alt="">{{ loginNickName }}</p>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">
              {{ $t('logOut') }}
            </el-dropdown-item>
            <el-dropdown-item command="2">
              {{ $t('editPw') }}
            </el-dropdown-item>
            <el-dropdown-item command="3">
              {{ $t('PersonalInformation') }}
            </el-dropdown-item>
            <el-dropdown-item command="4">
              {{ $t('addressBook') }}
            </el-dropdown-item>
            <el-dropdown-item command="5">
              {{ $t('monitorAddress') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>



        <img v-else @click="openLoginDialog" style="width: 5vw;margin-right: 3.5vw;" src="@/assets/img/notlogin.png"
          alt="">



        <i @click="drawer = true" class="openMenu el-icon-s-unfold"></i>
      </div>
    </div>
    <div class="content-all">
      <!-- 内容区域  每个模块的id要与menu的id一一对应-->
      <section class="content" id="gonglu">
        <img class="gongluBg" src="@/assets/img/bg.jpg" alt="">
        <div class="gongluContent">

          <div class="maintitle1">

            <p class="title1">{{ $t('tips1') }}</p>
            <h4>{{ $t('tips2') }}</h4>
          </div>
          <div class="dibu2-all">
            <div class="dibu2">
              <p id="marquee1"><span>{{ message }}</span><span>{{ message }}</span></p>
              <p id="marquee2"><span>{{ message }}</span><span>{{ message }}</span></p>
            </div>
          </div>
          <!-- <div class="exchangeDiv"> -->

          <div class="exchangeItem" style="margin-top: 14vw;">
            <!-- <div v-if="checkBindEnterprise()">
              <strong class="title3">{{ $t('AccountBalance') }}: <span class="num3" style="color: #31545D;">{{ accountBalance }}</span></strong>
            </div> -->
            <div>
              <strong class="title3">{{ $t('tips28') }}</strong>
              <div class="num1">{{ totalEnergy }}</div>
            </div>
            <div style="margin-top:6vw">
              <strong class="title3">{{ $t('tips28Bandwidth') }}</strong>
              <div class="num1">{{ totalBandwidth }}</div>
            </div>
            <div style="margin-top:6vw">
              <strong class="title3">{{ $t('tips29') }} <img @click="openQr" :title="$t('tips30')"
                  src="@/assets/img/qr.png" alt=""></strong>
              <div class="num1" id="num2">{{ address }} <img @click.stop="_copy(address)" src="@/assets/img/copy1.png"
                  alt=""> </div>
            </div>
            <el-button class="energyExchange" @click="openExchange" type="primary">{{ $t('energyExchange')
              }}</el-button>

          </div>

          <!-- </div> -->
          <div class="exchangeItem" style="background-color: #f3f3f3;">
            <h4 style="font-size:6vw;margin:8vw auto 4vw;text-align: center;">{{ $t('tips4') }}</h4>
            <ul class="ul-box">
              <li>{{ $t('tips5') }}</li>
              <li>{{ $t('tips6') }}</li>
              <li>{{ $t('tips7') }}</li>
              <li>{{ $t('tips8') }}</li>
            </ul>

          </div>

        </div>

      </section>



      <section class="content" id="transaction">

        <div class="tDiv">



          <div style="margin-bottom: 8vw;"  v-if="checkUserLogin()">

            <h3>{{ $t('rechargeHistory') }}</h3>
            <el-form inline class="search" style="width: 100vw;min-width:100vw;margin:6vw auto 0">


              <el-form-item>
                <!-- <el-button class="searchButton" type="primary" @click="openRecharge">{{ $t('recharge')
                  }}</el-button> -->
              </el-form-item>
            </el-form>
            <el-table class="tTable" :data="rechargeTableData" style="width: 100vw;min-width:100vw;margin:0 auto">
              <!-- <el-table-column prop="id" :label="$t('orderNo')">
              </el-table-column> -->
              <el-table-column prop="payAddress" :label="$t('Paymentaddress')">
              </el-table-column>
             <el-table-column prop="rechargeBalance" :label="$t('rechargeBalance')">
              </el-table-column>
              <!--  <el-table-column prop="txId" :label="$t('TxHash')">
              </el-table-column>
              <el-table-column prop="status" :label="$t('OrderState')">
              </el-table-column> -->
              <!-- <el-table-column prop="createTime" :label="$t('createTime')">
              </el-table-column> -->
            </el-table>
          </div>


          <div style="margin-top: 20vw;">
            <h3>{{ $t('tips31') }}</h3>
            <el-form inline class="search" style="width: 100vw;min-width:100vw;margin:6vw auto 0">
              <el-form-item label="">
                <el-input style="width:80vw" clearable v-model="keywords" :placeholder="$t('Keywords')"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button class="searchButton" type="primary" @click="getList()">{{ $t('search') }}</el-button>
              </el-form-item>
            </el-form>
            <el-table class="tTable" :data="tableData" style="margin:0 auto">
              <el-table-column prop="receiveAddress" :label="$t('Receivingaddress')">
              </el-table-column>

              <el-table-column :label="$t('Amount')">
                <template slot-scope="scope">
                  {{ displayOrderAmount(scope.row) }}
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>

      </section>
      <!--
      <section class="content" id="transaction">
        <div class="tDiv">
          <h3>{{ $t('tips31') }}</h3>
          <el-form inline class="search" style="width: 100vw;min-width:100vw;margin:6vw auto 0">
            <el-form-item label="">
              <el-input style="width:80vw" clearable v-model="keywords" :placeholder="$t('Keywords')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button class="searchButton" type="primary" @click="getList()">{{ $t('search') }}</el-button>
            </el-form-item>
          </el-form>
          <el-table class="tTable" :data="tableData" style="margin:0 auto">
            <el-table-column prop="receiveAddress" :label="$t('Receivingaddress')">
            </el-table-column>

            <el-table-column prop="energyAmount" :label="$t('Amount')">
            </el-table-column>

          </el-table>
        </div>

      </section> -->
      <!-- <section class="content" id="transaction">
        <div class="tDiv">
          <h3>{{ $t('tips31') }}</h3>
          <el-form inline class="search" style="width: 100vw;min-width:100vw;margin:6vw auto 0">
            <el-form-item label="">
              <el-input style="width:80vw" clearable v-model="keywords" :placeholder="$t('Keywords')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button class="searchButton" type="primary" @click="getList()">{{ $t('search') }}</el-button>
            </el-form-item>
          </el-form>
          <el-table class="tTable" :data="tableData" style="margin:0 auto">
            <el-table-column prop="receiveAddress" :label="$t('Receivingaddress')">
            </el-table-column>

            <el-table-column prop="energyAmount" :label="$t('Amount')">
            </el-table-column>

          </el-table>
        </div>

      </section> -->
      <section class="content" id="tielu">
        <div class="tlDivAll">
          <h3 class="tlH3">{{ $t('tips9') }}</h3>
          <div class="tlDiv">
            <div class="tlP">
              <img class="tlP1" src="@/assets/img/money.png" alt="">
              <span class="tlSpan">{{ $t('Economic') }}</span>
            </div>
            <div class="tlP">
              <img class="tlP1" src="@/assets/img/safe.png" alt="">

              <span class="tlSpan">{{ $t('SAFE') }}</span>
            </div>
            <div class="tlP">
              <img class="tlP1" src="@/assets/img/effect.png" alt="">

              <span class="tlSpan">{{ $t('EFFICIENT') }}</span>
            </div>

          </div>
          <p class="intro">{{ $t('tips10') }}</p>
          <ul class="tlUl">
            <li class="tlLi"><img src="@/assets/img/arrow.png" alt=""> {{ $t('tips11') }}</li>
            <li class="tlLi"><img src="@/assets/img/arrow.png" alt="">{{ $t('tips12') }}</li>
            <li class="tlLi"><img src="@/assets/img/arrow.png" alt="">{{ $t('tips13') }}</li>
            <li class="tlLi"><img src="@/assets/img/arrow.png" alt="">{{ $t('tips14') }}</li>
          </ul>
        </div>
      </section>
      <section class="content" id="shuilu">
        <h3>{{ $t('tips15') }}</h3>
        <ul class="ccUl">
          <li class="ccLi">
            <div class="ccPDiv">
              <p class="ccP">
                <img src="@/assets/img/times.png" alt="" />
              </p>

              <h4 class="ccH4">{{ $t('tips16') }}</h4>
            </div>
            <span class="ccSpan">{{ $t('tips17') }}</span>
          </li>
          <li class="ccLi">
            <div class="ccPDiv">
              <p class="ccP"><img src="@/assets/img/effect.png" alt=""></p>
              <h4 class="ccH4">{{ $t('tips18') }}</h4>
            </div>

            <span class="ccSpan">{{ $t('tips19') }}</span>
          </li>
          <li class="ccLi">
            <div class="ccPDiv">
              <p class="ccP"><img src="@/assets/img/order.png" alt=""></p>
              <h4 class="ccH4">{{ $t('tips20') }}</h4>
            </div>

            <span class="ccSpan">{{ $t('tips21') }}</span>
          </li>
          <li class="ccLi">
            <div class="ccPDiv">
              <p class="ccP"><img src="@/assets/img/repeat.png" alt=""></p>
              <h4 class="ccH4">{{ $t('tips22') }}</h4>
            </div>

            <span class="ccSpan">{{ $t('tips23') }}</span>
          </li>
        </ul>
      </section>

      <!-- <section class="content" id="cangchu">
      </section> -->
      <div class="footDiv">{{ $t('tips33') }}</div>
    </div>



    <el-dialog :close-on-click-modal="false" :title="$t('signUp')" :visible.sync="registerDialog" width="90vw">
      <el-form class="formDiv" label-width="100%" :model="registerData" :rules="registerRules" ref="registerData">
        <el-form-item prop="username" :label="$t('userName')">
          <el-input name="aaa" autocomplete="off" v-model="registerData.username"></el-input>
        </el-form-item>


        <el-form-item :label="$t('password')" prop="password">
          <el-input name="bbb" autocomplete="off" type="password" v-model="registerData.password"></el-input>

        </el-form-item>
        <el-form-item :label="$t('confirmPassword')" prop="confirmPassword">
          <el-input type="password" v-model="registerData.confirmPassword"></el-input>

        </el-form-item>
        <!-- <el-form-item :label="$t('EnterprisePayId')" prop="enterprisePayId">
          <el-input v-model="registerData.enterprisePayId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('EnterprisePayKey')" prop="enterprisePayKey">
          <el-input v-model="registerData.enterprisePayKey"></el-input>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="closeDialogRegister">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="loading2" class="title"
          @click="resisterAccount('registerData')">{{
          $t('signUp') }}</el-button>

      </div>

    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('login')" :visible.sync="loginDialog" width="90vw">

      <el-form class="formDiv" label-width="100%" :model="loginData" :rules="loginRules" ref="loginData">
        <el-form-item prop="username" :label="$t('userName')">
          <el-input name="ccc" autocomplete="off" v-model="loginData.username"></el-input>
        </el-form-item>


        <el-form-item :label="$t('password')" prop="password">
          <el-input name="ccc" autocomplete="off" type="password" v-model="loginData.password"></el-input>

        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="closeDialogLogin">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" class="title" @click="loginAccount('loginData')">{{
          $t('login') }}</el-button>
        <p class="register"> {{ $t('noAccount') }}<span @click="openRegisterDialog">{{ $t('register') }}</span></p>

      </div>

    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('balanceRecharge')" :visible.sync="rechargeDialog" width="90vw">
      <!-- 未配置专属地址 -->
      <div v-if="!userData.receiveAddress" style="margin-bottom: 20px;">
        <el-alert
          :title="$t('noExclusiveAddress')"
          type="info"
          :closable="false"
          style="margin-bottom: 15px;">
        </el-alert>
        <p style="color: #606266; font-size: 3.5vw; line-height: 1.8; margin-bottom: 15px;">
          {{ $t('noExclusiveAddressTip') }}
        </p>
        <p style="color: #606266; font-size: 3vw; line-height: 1.6; background: #f4f4f5; padding: 10px; border-radius: 4px;">
          <strong>{{ $t('notice') }}：</strong>{{ $t('generalRechargeNotice') }}
        </p>
      </div>

      <!-- 已配置专属地址 -->
      <div v-else style="margin-bottom: 20px;">
        <el-alert
          :title="$t('hasExclusiveAddress')"
          type="success"
          :closable="false"
          style="margin-bottom: 15px;">
        </el-alert>
        <div style="background: #f4f4f5; padding: 15px; border-radius: 4px; margin-bottom: 15px;">
          <p style="color: #606266; font-size: 3.5vw; margin-bottom: 10px;">{{ $t('yourExclusiveAddress') }}：</p>
          <div style="display: flex; align-items: center;">
            <p style="color: #31545D; font-size: 3.8vw; font-weight: bold; word-break: break-all; flex: 1; margin: 0;">
              {{ userData.receiveAddress }}
            </p>
            <i class="el-icon-document-copy" @click="_copy(userData.receiveAddress)" style="font-size: 5vw; color: #606266; cursor: pointer; margin-left: 2vw;" :title="$t('copy')"></i>
          </div>
        </div>
        <p style="color: #606266; font-size: 3vw; line-height: 1.6; margin-bottom: 15px;">
          {{ $t('exclusiveAddressTip') }}
        </p>
        <p style="color: #606266; font-size: 3vw; margin-bottom: 10px;">
          {{ $t('canStillUseGeneral') }}
        </p>
        <p style="color: #606266; font-size: 3vw; line-height: 1.6; background: #f4f4f5; padding: 10px; border-radius: 4px;">
          <strong>{{ $t('notice') }}：</strong>{{ $t('generalRechargeNotice') }}
        </p>
      </div>

      <el-divider></el-divider>

      <el-form class="formDiv" label-width="100%" :model="rechargeFormData" :rules="rulesRecharge"
        ref="rechargeFormData">
        <el-form-item :label="$t('Paymentaddress')" prop="payAddress">
          <el-input v-model="rechargeFormData.payAddress"></el-input>
        </el-form-item>

        <el-form-item :label="$t('rechargeBalance')" prop="amount">
          <el-input type="number" v-model.number="rechargeFormData.amount"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="closeRechargeDialog">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="loading3" class="title"
          @click="confirmRecharge('rechargeFormData')">{{
          $t('confirmRecharge') }}</el-button>
      </div>
    </el-dialog>


    <el-dialog :close-on-click-modal="false" :title="$t('energyExchange')" :visible.sync="exchangeDialog" width="90vw">
      <div slot="title" class="dialog-title">
        <span>{{ $t('energyExchange') }}</span>

        <el-dropdown trigger="hover" @command="handleSetUser" class="changeUserBox">

          <span class="changeUser">{{ ordinary ? $t('Ordinaryuser') : $t('Enterpriseuser') }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="ordinary" command="ord">
              {{ $t('Ordinaryuser') }}
            </el-dropdown-item>
            <el-dropdown-item :disabled="!ordinary" command="ent">
              {{ $t('Enterpriseuser') }}

            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-form class="formDiv" label-width="100%" :model="formData" :rules="rules" ref="formData">
        <el-form-item v-if="!ordinary" prop="enterprisePayId" :label="$t('EnterprisePayId')">
          <el-input @blur="getPrice(formData.enterprisePayId)" v-model="formData.enterprisePayId"></el-input>
        </el-form-item>
        <p v-if="!ordinary && selectKey" style="color:#31545D;">{{ $t('PromitBalance') }} : {{ this.enterpriseBalance }}
          TRX
        </p>

        <el-form-item :label="$t('Receivingaddress')" prop="receiveAddress">
          <el-input v-model="formData.receiveAddress">
            <el-button slot="append" @click="openAddressSelect('receive')">{{ $t('addressBook') }}</el-button>
          </el-input>
        </el-form-item>

        <el-form-item v-if="ordinary" :label="$t('Paymentaddress')" prop="payAddress">
          <el-input v-model="formData.payAddress">
            <el-button slot="append" @click="openAddressSelect('pay')">{{ $t('addressBook') }}</el-button>
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('resourceType')" prop="resourceType">
          <el-select v-model="formData.resourceType" :placeholder="$t('pleaseSelect')" @change="onExchangeResourceTypeChange">
            <el-option v-for="item in resourceTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="getAmountLabel()" prop="energyAmount">
          <el-input type="number" :disabled="!ordinary" v-model="formData.energyAmount"></el-input>

          <div class="nums">
            <p v-if="ordinary">

              <span class="numsSpan" :style="{ 'background': ordinary ? '#ffffff' : '#F5F7FA' }" @click="toValue(item)"
                v-for="(item, index) in getPresetAmounts()" :key="index">
                {{ item }}<span v-if="getPresetAmountLabel(index)" class="presetLabel"> ({{ getPresetAmountLabel(index) }})</span>
              </span>
            </p>
            <p v-if="!ordinary" class="numsP"> <span>{{ $t('Transactioncount') }}: <el-input @input="changeNumber"
                  size="small" v-model="number1" :min="1" :max="1000" type="number"></el-input> </span> </p>

          </div>
          <p class="transTips"> <span>{{ $t('tips') }}：</span> {{ getTransactionTip() }}</p>
          <p v-if="getCurrentResourceType() === 'BANDWIDTH'" class="bandwidthMinTip"> ⚠️ {{ $t('bandwidthMinTip', { amount: bandwidthMinAmount.toLocaleString('en-US') }) }} · {{ $t('bandwidthAmountStepTip') }}</p>

        </el-form-item>

        <el-form-item v-if="!ordinary" prop="enterprisePayKey" :label="$t('EnterprisePayKey')">
          <el-input v-model="formData.enterprisePayKey"></el-input>
        </el-form-item>
        <el-form-item v-if="ordinary || !ordinary && selectKey" :label="$t('Price')" prop="unitPriceId">
          <el-select v-model="formData.unitPriceId" :placeholder="$t('pleaseSelect')">
            <el-option v-for="item in filteredPriceOptions()" :key="item.id" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          v-if="$route.query.hasOwnProperty('Referral')"
          :label="$t('referralCode')"
          prop="referralCode"
        >
          <el-input
            disabled
            v-model="formData.referralCode"
          ></el-input>

        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="closeDialog">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('formData')">{{
          $t('Createorder') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('OnlineService')" :visible.sync="dialogVisible" width="75vw">
      <h3 class="kfH3">{{ $t('tips24') }}</h3>
      <div class="kfDiv">

        <img class="kfP" src="@/assets/img/telegram.png" alt="">
        <p class="kfSpan">{{ customerServiceAddress }}</p>
        <el-button type="primary" @click="_copy({ customerServiceAddress })"><img class="copy_white"
            src="@/assets/img/copy_white.png" alt="">{{ $t('tips25') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('QRcode')" :visible.sync="qrDialog" width="80vw">
      <div style="padding:0 6vw;text-align:center;">
        <img ref="imageContainer" class="qrcode" :src="qrCodePath" alt="">
        <el-button style="margin:6vw auto 0" type="primary" @click="downloadImg">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('tips')" :visible.sync="tipsDialog" width="90vw">
      <p style="text-align: center;" class="dAddress" v-if="enableEnterpriseBalance">
        {{ $t('tips36') }}
      </p>
      <div v-else>
        <p class="dP" v-if="language === 'zh'"> 请支付 <span class="money">{{ money }} TRX</span> 到
          <br><span class="dAddress">{{
          address }}</span>
        </p>
        <p class="dP" v-else>Please pay <span class="money">{{ money }} TRX</span> to
          <br> <span class="dAddress">{{ address
            }}</span>
        </p>
      </div>
      <div style="padding:0 24px;text-align:center;">
        <img ref="imageContainer" class="qrcodePaid" :src="qrCodePath" alt="">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="tipsDialog = false">{{ $t('Completepayment') }}</el-button>
        <el-button v-if="!enableEnterpriseBalance" size="small" type="primary" :loading="loading" class="title"
          @click="_copy(address)">{{
          $t('Copyaddress') }}</el-button>
      </div>
    </el-dialog>


    <el-dialog :close-on-click-modal="false" :title="$t('editPw')" :visible.sync="editPwDialog" width="90vw">
      <el-form class="formDiv" label-width="100%" :model="editPwData" :rules="editPwRules" ref="editPwData">
        <el-form-item prop="password" :label="$t('oldPw')">
          <el-input autocomplete="off" type="password"  v-model="editPwData.password"></el-input>
        </el-form-item>


        <el-form-item :label="$t('newPw')" prop="newPassword">
          <el-input autocomplete="off" type="password" v-model="editPwData.newPassword"></el-input>

        </el-form-item>
        <el-form-item :label="$t('confirmPassword')" prop="confirmPwd">
          <el-input autocomplete="off" type="password" v-model="editPwData.confirmPwd"></el-input>

        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="closeDialog1">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="loading4" class="title" @click="editPWD('editPwData')">{{
          $t('confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="$t('PersonalInformation')" :visible.sync="personalInfoDialog" width="90vw">
      <div class="info-box">
      <div><span class="info1">{{ $t('userName') }}:</span>  <span  class="info2">{{ userData.username }}</span></div>
      <div><span  class="info1">{{ $t('EnterprisePayKey') }} :</span>
        <p v-if="hideKey" class="info2"><span class="xing"> ********************************</span> <img class="eye" @click="hideKey = !hideKey" src="@/assets/img/openeye.png" alt="">  </p>
        <p v-if="!hideKey" class="info2">{{ nowStr }} <img class="eye" @click="hideKey = !hideKey" src="@/assets/img/closeeye.png" alt="">  </p>

        </div>
        <div><span class="info1">{{ $t('EnterprisePayId') }} :</span> <span class="info2">tron_energy_{{userData.id}}_delegate</span></div>

      <div style="margin-bottom: 2vw;">
        <span class="info1">{{ $t('AccountBalance') }}:</span>
        <span class="info2" style="display: block; margin: 1vw 0;">{{ userData.balance }}</span>
        <div style="display: flex; gap: 2vw; margin-top: 1vw;">
          <el-button size="small" type="primary" :loading="refreshingBalance" @click="refreshBalance" style="flex: 1;">{{ $t('refresh') }}</el-button>
          <el-button size="small" type="primary" @click="openRecharge" style="flex: 1;">{{ $t('recharge') }}</el-button>
        </div>
      </div>
        

      </div>
      <el-form class="loginForm" :model="notificationSettings" :rules="notificationRules"
        ref="notificationForm" style="margin-top:20px">
        <el-form-item :label="$t('balanceNotifyThreshold')" prop="balance_notify">
          <el-input style="width: 100%;" :placeholder="$t('pleaseInput')" v-model.number="notificationSettings.balance_notify"
            type="number" :disabled="notificationSettings.balance_notify_interval === 0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('balanceNotifyInterval')" prop="balance_notify_interval">
          <el-select v-model="notificationSettings.balance_notify_interval" :placeholder="$t('pleaseSelect')" @change="handleIntervalChange" style="width: 100%;">
            <el-option
              v-for="item in notificationIntervalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">


        <el-button class="cancel" size="small" @click="personalInfoDialog = false">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="loadingNotification" class="title"
          @click="saveNotificationSettings">{{
            $t('save') }}</el-button>
      </div>
    </el-dialog>

    <el-drawer size="50vw" :visible.sync="drawer" :direction="direction" :show-close="false">
      <img class="logo1" src="@/assets/img/Tron.png" alt="">
      <!-- 侧边栏 -->
      <ul class="sidebar">

        <li v-for="item in menu" :key="item.name" :class="{ active: 1 === item.active }">

          <a href="javascript:;" @click="scrollTo(item)"> <img v-if="item.icon" src="@/assets/img/service.png"
              alt=""><span>{{ item.name }}</span></a>
        </li>
        <div class="lang">

          <el-dropdown trigger="hover" class="international" @command="handleSetLanguage">
            <div>
              <img class="global" src="@/assets/img/global.png" alt="">
              <span class="Switchlanguage">{{ $t('Switchlanguage') }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="language === 'zh'" command="zh">
                中文
              </el-dropdown-item>
              <el-dropdown-item :disabled="language === 'en'" command="en">
                English
              </el-dropdown-item>
              <el-dropdown-item :disabled="language === 'vi'" command="vi">
                Vietnamese
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>


      </ul>
    </el-drawer>

    <!-- 地址簿弹窗 -->
    <el-dialog :title="$t('addressBook')" :visible.sync="addressBookVisible" width="90%">
      <div class="address-book">
        <!-- 地址列表 -->
        <div class="address-list">
          <el-table :data="addressList" style="width: 100%">
            <el-table-column prop="address" :label="$t('address')" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('operations')" width="80">
              <template slot-scope="scope">
                <el-button @click="handleDeleteAddress(scope.row)" type="text" size="small">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 添加地址表单 -->
        <div class="add-address" style="margin-top: 20px;">
          <el-form :model="addressForm" ref="addressForm" :rules="addressRules">
            <el-form-item prop="address">
              <el-input v-model="addressForm.address" :placeholder="$t('pleaseInputAddress')">
                <el-button slot="append" @click="handleAddAddress">{{ $t('add') }}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 地址选择弹窗 -->
    <el-dialog
      :title="$t('addressBook')"
      :visible.sync="addressSelectVisible"
      width="90%"
      append-to-body
    >
      <el-table
        :data="addressList"
        style="width: 100%"
        @row-click="handleAddressSelect"
      >
        <el-table-column prop="address" :label="$t('address')" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 监控地址弹窗 -->
    <el-dialog :title="$t('monitorAddress')" :visible.sync="monitorAddressVisible" width="90%">
      <div class="monitor-address">
        <!-- 监控地址列表 -->
        <div class="monitor-address-list">
          <el-table :data="monitorAddressList" style="width: 100%">
            <el-table-column prop="monitorAddress" :label="$t('address')" show-overflow-tooltip>
            </el-table-column>
            <el-table-column :label="$t('resourceType')" width="90" align="center">
              <template slot-scope="scope">
                {{ getMonitorResourceTypeLabel(scope.row.resourceType) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('monitorThreshold')" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ getMonitorThresholdValue(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('rentalAmount')" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ getMonitorAmountValue(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="showPrice" :label="$t('unitprice')" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('operations')" width="80" align="center">
              <template slot-scope="scope">
                <el-button @click="handleDeleteMonitorAddress(scope.row)" type="text" size="small">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 添加监控地址表单 -->
        <div class="add-monitor-address" style="margin-top: 20px;">
          <el-form :model="monitorAddressForm" ref="monitorAddressForm" :rules="monitorAddressRules">
            <el-form-item prop="address" :label="$t('address')">
              <el-input v-model="monitorAddressForm.address" :placeholder="$t('pleaseInputAddress')"></el-input>
            </el-form-item>
            <el-form-item prop="resourceType" :label="$t('resourceType')">
              <el-select v-model="monitorAddressForm.resourceType" :placeholder="$t('pleaseSelect')" @change="onMonitorResourceTypeChange">
                <el-option v-for="item in resourceTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="monitorThresholdValue" :label="$t('monitorThreshold')">
              <el-input v-if="monitorAddressForm.resourceType === 'BANDWIDTH'" v-model.number="monitorAddressForm.bandwidthThreshold" :placeholder="$t('pleaseInputBandwidthThreshold')" type="number" min="0" max="100000000"></el-input>
              <el-input v-else v-model.number="monitorAddressForm.energyThreshold" :placeholder="$t('pleaseInputEnergyThreshold')" type="number" min="0" max="100000000"></el-input>
            </el-form-item>
            <el-form-item prop="unitPriceId" :label="$t('Price')">
              <el-select v-model="monitorAddressForm.unitPriceId" :placeholder="$t('pleaseSelect')"  @focus="getPriceWithLogin">
                <el-option v-for="item in monitorPriceOptions()" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="monitorAmountValue" :label="$t('rentalAmount')">
              <el-input v-if="monitorAddressForm.resourceType === 'BANDWIDTH'" v-model.number="monitorAddressForm.bandwidthAmount" :placeholder="$t('pleaseInputBandwidthAmount')" type="number" :min="bandwidthMinAmount"></el-input>
              <el-input v-else v-model.number="monitorAddressForm.energyAmount" :placeholder="$t('pleaseInputEnergyAmount')" type="number" min="100"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleAddMonitorAddress">{{ $t('add') }}</el-button>
              <el-button type="primary" @click="openMonitorIntervalDialog" style="margin-left: 10px;">{{ $t('setMonitorInterval') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 监听间隔设置弹窗 -->
    <el-dialog :title="$t('setMonitorInterval')" :visible.sync="monitorIntervalVisible" width="90%">
      <el-form :model="monitorIntervalForm" :rules="monitorIntervalRules" ref="monitorIntervalForm">
        <el-form-item :label="$t('monitorInterval')" prop="monitorNotifyInterval">
          <el-select v-model="monitorIntervalForm.monitorNotifyInterval" :placeholder="$t('pleaseSelect')" style="width: 100%;">
            <el-option
              v-for="item in monitorIntervalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" size="small" @click="monitorIntervalVisible = false">{{ $t('cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="loadingMonitorInterval" class="title" @click="saveMonitorInterval">{{
          $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

// import i18n from "@/i18n" //根据项目对应真实路径

// i18n.locale = "en" // 改变为中文
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import { enterpriseBalance, unitPriceList, orderCreate, dashboard, list, getDigest, userCreate, userLogin, rechargeCreate ,editPwd,getUserInfo,aesDecrypt,aesEncrypt, getAddressList, createAddress, deleteAddress, getMonitorAddressList, createMonitorAddress, deleteMonitorAddress, listWithLogin, updateBalanceNotify, updateMonitorNotifyInterval } from '@/api/basisMG'
import { setStore, getStore, removeStore, formatNumber } from '@/utils/util'

export default {
  props: {},
  data() {
    return {
      hideKey: true,
      nowStr: '',
      userData: {},
      personalInfoDialog: false,
      refreshingBalance: false,
      bandwidthMinAmount: 5000,
      notificationSettings: {
        balance_notify: null,
        balance_notify_interval: null
      },
      notificationIntervalOptions: [
        { value: 0, label: this.$t('never') },
        { value: 600, label: this.$t('tenMinutes') },
        { value: 1800, label: this.$t('thirtyMinutes') },
        { value: 43200, label: this.$t('twelveHours') },
        { value: 86400, label: this.$t('oneDay') },
        { value: 604800, label: this.$t('sevenDays') }
      ],
      notificationRules: {
        balance_notify: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === '' || (value >= -1 && value <= 10000000)) {
                callback();
              } else {
                callback(new Error(this.$t('valueRangeError')));
              }
            }, trigger: 'blur'
          }
        ],
        balance_notify_interval: [
          { required: true, message: this.$t('pleaseSelect'), trigger: 'change' }
        ]
      },
      loadingNotification: false,
      loading4: false,
      editPwDialog: false,
      editPwData: {
        password: '',
        newPassword: '',
        confirmPwd: '',
      },
      editPwRules: {
        password: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
      },
      registerData: {
        username: '',
        password: '',
        confirmPassword: '',
        enterprisePayId: '',
        enterprisePayKey: ''
      },
      registerDialog: false,
      loginData: {
        username: '',
        password: ''
      },
      loginNickName: '',
      loading1: false,
      loading2: false,
      loading3: false,
      ordinary: true,
      selectKey: false,
      enableEnterpriseBalance: false,
      enterpriseBalance: '',
      number1: null,

      direction: 'rtl',
      drawer: false,
      money: 0,
      tipsDialog: false,
      totalEnergy: 0,
      totalBandwidth: 0,
      accountBalance: 0,
      payAddress: '',
      receiveAddress: '',
      keywords: '',
      searchText: '',
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      rechargeTableData: [],
      qrDialog: false,
      address: '',
      qrCodePath: '',
      customerServiceAddress: '',
      loading: false,
      language: this.$i18n.locale,
      dialogVisible: false,
      formData: {},
      rechargeFormData: {},

      // rules表单验证
      registerRules: {
        username: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
      },
      loginRules: {
        username: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
      },


      rulesRecharge: {

        payAddress: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 0) {
                callback();

              } else {
                callback(new Error(this.$t('tips26')));

              }
            },
            trigger: "blur",
          },
        ],

        enterprisePayKey: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        enterprisePayId: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],

      },
      rules: {
        receiveAddress: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        payAddress: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        energyAmount: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              console.log(value)
              if (value <= 0) {
                callback(new Error(this.$t('tips26')));
                return
              }
              if (this.getCurrentResourceType() === 'BANDWIDTH' && Number(value) < this.bandwidthMinAmount) {
                callback(new Error(this.$t('bandwidthAmountTooSmall', { amount: this.bandwidthMinAmount.toLocaleString('en-US') })));
                return
              }
              callback();
            },
            trigger: "blur",
          },
        ],

        unitPriceId: [
          { required: true, message: this.$t('pleaseSelect'), trigger: 'change' }
        ],
        resourceType: [
          { required: true, message: this.$t('pleaseSelect'), trigger: 'change' }
        ],
        enterprisePayKey: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        enterprisePayId: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
        referralCode: [
          { required: true, message: this.$t('pleaseInput'), trigger: 'blur' }
        ],
      },
      selectVal: '',
      loginDialog: false,
      resourceTypeOptions: [
        { label: this.$t('energy'), value: 'ENERGY' },
        { label: this.$t('bandwidth'), value: 'BANDWIDTH' }
      ],

      options: [],
      rechargeDialog: false,

      exchangeDialog: false,
      message: '',
      marqueeVar: null,
      speed1: 0,
      speed2: 0,

      menu: [
        {
          name: this.$t('energyExchange'),
          id: 'gonglu',
          active: 0, // 用来判断侧边栏的激活状态，为1则代表激活，class的active为true。
        },
        {
          name: this.$t('tips31'),
          id: 'transaction',
          active: 0, // 用来判断侧边栏的激活状态，为1则代表激活，class的active为true。
        },
        {
          name: this.$t('Aboutus'),
          id: 'tielu',
          active: 0,
        },
        {
          name: this.$t('FAQ'),
          id: 'shuilu',
          active: 0,
        },
        {
          name: this.$t('Support'),
          id: 'cangchu',
          active: 0,
          icon: true

        }
      ],
      addressBookVisible: false,
      addressSelectVisible: false,
      addressList: [],
      addressForm: {
        address: ''
      },
      addressRules: {
        address: [
          { required: true, message: this.$t('pleaseInputAddress'), trigger: 'blur' }
        ]
      },
      addressSelectType: '',
      monitorAddressVisible: false,
      monitorAddressList: [],
      monitorAddressForm: {
        address: '',
        resourceType: 'ENERGY',
        energyThreshold: null,
        bandwidthThreshold: null,
        unitPriceId: null,
        energyAmount: null,
        bandwidthAmount: null
      },
      monitorAddressRules: {
        address: [
          { required: true, message: this.$t('pleaseInputAddress'), trigger: 'blur' }
        ],
        resourceType: [
          { required: true, message: this.$t('pleaseSelect'), trigger: 'change' }
        ],
        monitorThresholdValue: [
          { validator: (rule, value, callback) => {
              const threshold = this.monitorAddressForm.resourceType === 'BANDWIDTH'
                ? this.monitorAddressForm.bandwidthThreshold
                : this.monitorAddressForm.energyThreshold
              if (threshold === null || threshold === undefined || threshold === '' || isNaN(Number(threshold))) {
                callback(new Error(this.$t('pleaseInputMonitorThreshold')));
              } else if (Number(threshold) < 0 || Number(threshold) > 100000000) {
                callback(new Error(this.$t('monitorThresholdRange')));
              } else {
                callback();
              }
            }, trigger: 'blur' }
        ],
        monitorAmountValue: [
          { validator: (rule, value, callback) => {
              const amount = this.monitorAddressForm.resourceType === 'BANDWIDTH'
                ? this.monitorAddressForm.bandwidthAmount
                : this.monitorAddressForm.energyAmount
              if (amount === null || amount === undefined || amount === '' || isNaN(Number(amount))) {
                callback(new Error(this.$t('pleaseInputRentalAmount')));
              } else if (Number(amount) < 100 || Number(amount) > 1000000000) {
                callback(new Error(this.$t('rentalAmountRange')));
              } else {
                callback();
              }
            }, trigger: 'blur' }
        ],
        unitPriceId: [
          { required: true, message: this.$t('pleaseSelect'), trigger: 'change' },
          { validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t('pleaseSelect')));
                return;
              }
              const targetType = this.monitorAddressForm.resourceType || 'ENERGY'
              const selected = this.options.find(item => item.id === value)
              const selectedType = selected && selected.resourceType ? selected.resourceType : 'ENERGY'
              if (selected && selectedType !== targetType) {
                callback(new Error(this.$t('monitorPriceTypeMismatch')));
              } else {
                callback();
              }
            }, trigger: 'change' }
        ]
      },
      // 监听间隔设置相关
      monitorIntervalVisible: false,
      loadingMonitorInterval: false,
      monitorIntervalForm: {
        monitorNotifyInterval: null
      },
      monitorIntervalOptions: [
        { value: 0, label: this.$t('never') },
        { value: 1, label: this.$t('oneHour') },
        { value: 3, label: this.$t('threeHours') },
        { value: 6, label: this.$t('sixHours') },
        { value: 12, label: this.$t('twelveHours') },
        { value: 24, label: this.$t('twentyFourHours') }
      ],
      monitorIntervalRules: {
        monitorNotifyInterval: [
          { required: true, message: this.$t('pleaseSelect'), trigger: 'change' }
        ]
      }
    }
  },
  mounted() {


    // this.$i18n.locale = 'zh'   //默认为中文
    //获取每个模块的参数，因为模块在整页渲染完毕后，offsetTop和scrollHeight值已经是确立的，所以在滚动监听之前可以先获取，暂存在menu中。
    this.menu.forEach(item => {
      item.offsetTop =document.getElementById(item.id)&& document.getElementById(item.id).offsetTop;
      item.scrollHeight = document.getElementById(item.id)&&document.getElementById(item.id).scrollHeight;
    })
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll)
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
  created() {

    var loginUser = getStore("loginUser")
    if (loginUser) {
      var loginUserObj = JSON.parse(loginUser)
      this.loginNickName = loginUserObj.username
    }




    if (localStorage.getItem("lang")) {
      this.$i18n.locale = localStorage.getItem("lang");
      this.language = localStorage.getItem("lang")
    } else {
      localStorage.setItem("lang", 'en')
      this.$i18n.locale = this.language = 'en'
    }
    this.getDash();




    this.getList();
    console.log(localStorage.getItem("lang"))


    setTimeout(() => {
      this.runMarquee()
    }, 1000)
  },
  methods: {
    getCurrentResourceType() {
      if (this.formData && this.formData.resourceType) {
        return this.formData.resourceType
      }
      const selectedPrice = this.options.find(item => item.id === this.formData.unitPriceId)
      return selectedPrice && selectedPrice.resourceType ? selectedPrice.resourceType : 'ENERGY'
    },
    filteredPriceOptions() {
      const selectedType = (this.formData && this.formData.resourceType) ? this.formData.resourceType : 'ENERGY'
      return this.options.filter(item => (item.resourceType || 'ENERGY') === selectedType)
    },
    onExchangeResourceTypeChange() {
      this.formData.unitPriceId = null
      if (!this.ordinary && this.number1) {
        this.changeNumber(this.number1)
      }
    },
    syncExchangeResourceTypeFromOptions() {
      const availableTypes = [...new Set(this.options.map(item => item.resourceType || 'ENERGY'))]
      if (availableTypes.length === 0) {
        this.formData.resourceType = 'ENERGY'
        this.formData.unitPriceId = null
        return
      }
      if (!availableTypes.includes(this.formData.resourceType)) {
        this.formData.resourceType = availableTypes[0]
        this.formData.unitPriceId = null
        return
      }
      const exists = this.options.some(item =>
        item.id === this.formData.unitPriceId && (item.resourceType || 'ENERGY') === this.formData.resourceType)
      if (!exists) {
        this.formData.unitPriceId = null
      }
    },
    displayOrderAmount(order) {
      const resourceType = order && order.resourceType ? order.resourceType : 'ENERGY'
      return resourceType === 'BANDWIDTH' ? order.bandwidthAmount : order.energyAmount
    },
    getAmountLabel() {
      return this.getCurrentResourceType() === 'BANDWIDTH' ? this.$t('RentingBandwidth') : this.$t('Rentingenergy')
    },
    getAmountScale() {
      return this.getCurrentResourceType() === 'BANDWIDTH' ? 280 : 65000
    },
    getPresetAmounts() {
      // BANDWIDTH 使用带宽数值快捷键(最小 5000 带宽, 20笔=5600, 40笔=11200)
      if (this.getCurrentResourceType() === 'BANDWIDTH') {
        return [
          this.bandwidthMinAmount.toLocaleString('en-US'),
          (this.bandwidthMinAmount + 600).toLocaleString('en-US'),
          (this.bandwidthMinAmount + 6200).toLocaleString('en-US')
        ]
      }
      const base = this.getAmountScale()
      return [base, base * 2, base * 3].map(item => item.toLocaleString('en-US'))
    },
    getPresetAmountLabel(index) {
      if (this.getCurrentResourceType() === 'BANDWIDTH') {
        if (index === 0) return this.$t('bandwidthPresetMin')
        if (index === 1) return this.$t('bandwidthPreset20')
        if (index === 2) return this.$t('bandwidthPreset40')
      }
      return null
    },
    getTransactionTip() {
      return this.getCurrentResourceType() === 'BANDWIDTH' ? this.$t('tips34Bandwidth') : this.$t('tips34')
    },
    getDash(){
      dashboard().then(res => {
      console.log(res, '111')
      this.qrCodePath = res.qrCodePath
      this.address = res.receiveAddress
      this.totalEnergy = formatNumber(res.totalEnergy)
      this.totalBandwidth = formatNumber(res.totalBandwidth)
      this.accountBalance = formatNumber(res.enterpriseBalance)
      this.customerServiceAddress = res.customerServiceAddress
      var lang = localStorage.getItem("lang")
      this.message = (function(lang) {
        switch (lang) {
          case 'zh': return res.znNotice
          case 'en': return res.enNotice
          case 'vi': return res.vnNotice
          default: return res.enNotice
        }
      })(lang)
      this.rechargeTableData = res.rechargeOrderPage.records
      this.rechargeTableData.forEach(item => {
        item.rechargeBalance = formatNumber(item.rechargeBalance);
      });
    })


    },
    async openRecharge() {
      // 获取用户信息以判断是否有专属地址
      try {
        const res = await getUserInfo()
        this.userData = res
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
      this.rechargeDialog = true
    },
    checkUserLogin() {
      var loginUser = getStore("loginUser")
      if (loginUser) {
        return true
      }
      return false
    },
    checkBindEnterprise() {
      var loginUser = getStore("loginUser")
      if (loginUser&&loginUser.referralCode) {
        return true
      }
      return false
    },

    openRegisterDialog() {
      this.registerDialog = true
    },
    openLoginDialog() {
      this.loginDialog = true
    },
    changeNumber(num) {
      console.log(num)

      if (Number.isInteger(Number(num))) {
        this.formData.energyAmount = parseInt(num) * this.getAmountScale()

      } else {

        this.$message.warning(this.$t('tips35'));
        this.formData.energyAmount = null
      }

    },
    toValue(num) {
      if (this.ordinary) {
        this.formData.energyAmount = Number(num.replace(/,/g, ''))

      }
    },
    getList() {
      if (this.keywords && this.keywords.trim()) {
        list({ keywords: this.keywords }).then(res => {
          this.tableData = res.data
          this.tableData.forEach(item => {
              item.energyAmount = formatNumber(item.energyAmount);
              item.bandwidthAmount = formatNumber(item.bandwidthAmount);
          });
        })
      } else {
        this.tableData = []
      }
    },
    downloadImg() {
      html2canvas(this.$refs.imageContainer)
        .then(canvas => {
          canvas.toBlob(blob => {
            saveAs(blob, 'qr.png');
          });
        });
    },
    closeDialogRegister() {
      this.$refs['registerData'].resetFields()
      this.registerDialog = false
    },
    closeDialogLogin() {
      this.$refs['loginData'].resetFields()
      this.loginDialog = false

    },
    closeRechargeDialog() {
      this.$refs['rechargeFormData'].resetFields()
      this.rechargeDialog = false

    },
    closeDialog() {
      this.$refs['formData'].resetFields()
      this.exchangeDialog = false

    },
    closeDialog1() {
      this.$refs['editPwData'].resetFields()
      this.editPwDialog = false

    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang
      localStorage.setItem("lang", lang)
      clearInterval(this.marqueeVar);
      location.reload()
    },
    changeBtn(command) {
      if (command === '1') {
        this.logOut()
      } else if (command === '2') {
        this.editPwDialog = true
      } else if (command === '3') {
        getUserInfo().then(res => {
          this.userData = res
          this.notificationSettings.balance_notify = res.balanceNotify
          this.notificationSettings.balance_notify_interval = res.balanceNotifyInterval
          let str = this.userData.payKey.substring(32)
          let str1 = str.slice(0, -13);
          this.nowStr = aesDecrypt(str1)
          this.personalInfoDialog = true;
        })
      } else if (command === '4') {
        this.addressBookVisible = true
        this.getAddressList()
      } else if (command === '5') {
        this.monitorAddressVisible = true
        this.getMonitorAddressList()
      }
    },
    logOut() {
      removeStore('loginUser')
      location.reload()


    },
    handleSetUser(mark) {
      if (mark === 'ord') {
        this.getPrice('');


        this.formData = {
          receiveAddress: '',
          payAddress: '',
          energyAmount: null,
          unitPriceId: null,
          resourceType: 'ENERGY',

        }

      } else {
        this.number1 = null
        this.selectKey = false

        this.formData = {
          receiveAddress: '',
          energyAmount: null,
          unitPriceId: null,
          resourceType: 'ENERGY',
          enterprisePayKey: '',
          enterprisePayId: '',
        }
      }

      this.ordinary = mark === 'ord'

      if (this.$route.query.hasOwnProperty('Referral')) {
        this.formData.referralCode = this.$route.query.Referral
      }
    },
    openQr() {
      this.qrDialog = true
    },
    _copy(context) {
      // 创建输入框元素
      let oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message.success(this.$t('replicatingSuccess'));
      // 复制后移除输入框
      oInput.remove();
    },
    resisterAccount(editData) {
      this.loading2 = true
      this.$refs[editData].validate(valid => {
        if (valid) {
          // let enterprisePayKey = this.registerData.enterprisePayKey
          // delete (this.registerData.enterprisePayKey)
          // delete (this.registerData.dataDigest)
          // delete (this.registerData.confirmPassword)
          // if (enterprisePayKey) {
          //   this.registerData.dataDigest = getDigest(JSON.stringify(this.registerData), enterprisePayKey);
          // }
          const encryptedData = {
            username: aesEncrypt(this.registerData.username),
            password: aesEncrypt(this.registerData.password),
            confirmPassword: aesEncrypt(this.registerData.confirmPassword)
          }
          if (this.$route.query.hasOwnProperty('Referral')) {
            encryptedData.referralCode = this.$route.query.Referral
          }
          userCreate(encryptedData).then(res => {
            this.loginNickName = this.registerData.username // 使用原始用户名
            setStore("loginUser", res)
            this.registerDialog = false
            this.loginDialog = false
            this.loading2 = false
            return true
          }).catch(error => {
            this.loading2 = false

          })
        } else {

          this.loading2 = false
          return false
        }
      })
    },
    loginAccount(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 创建一个新对象用于发送请求,避免修改原始数据
          const encryptedData = {
            username: aesEncrypt(this.loginData.username),
            password: aesEncrypt(this.loginData.password)
          }
          userLogin(encryptedData).then(res => {
            this.loginNickName = this.loginData.username // 使用原始用户名
            setStore("loginUser", res)
            this.loginDialog = false
            location.reload()
            return true
          })
        }
      })
    },

    confirmRecharge(formData) {
      this.loading3 = true

      this.$refs[formData].validate(valid => {
        if (valid) {


          // let enterprisePayKey = this.rechargeFormData.enterprisePayKey
          // delete (this.rechargeFormData.enterprisePayKey)
          // delete (this.rechargeFormData.dataDigest)


          // this.rechargeFormData.dataDigest = getDigest(JSON.stringify(this.rechargeFormData), enterprisePayKey);



          rechargeCreate(this.rechargeFormData).then(res => {

            console.log(res)


            this.loading3 = false
            this.rechargeDialog = false
            this.money = res.rechargeBalance;
            this.getList()
            this.tipsDialog = true;

            this.getDash();

          }).catch(error => {
            this.loading3 = false

          })


        } else {
          this.loading3 = false

          return false
        }
      })
    },

    editPWD(editData){
      this.loading4 = true

      this.$refs[editData].validate(valid => {
        if (valid) {
            // 创建加密数据对象
            const encryptedData = {
              password: aesEncrypt(this.editPwData.password),
              newPassword: aesEncrypt(this.editPwData.newPassword),
              confirmPwd: aesEncrypt(this.editPwData.confirmPwd)
            }

            editPwd(encryptedData).then(() => {
            this.$message.success(this.$t('tips38'))
            this.editPwDialog = false
            removeStore('loginUser')
            location.reload()
          }).catch(() => {
            this.loading4 = false
          })
        } else {
          this.loading4 = false
        }
      })


    },

    submitForm(editData) {
      this.loading = true

      this.$refs[editData].validate(valid => {
        if (valid) {
          const payload = { ...this.formData }
          const selectedPrice = this.options.find(item => item.id === payload.unitPriceId)
          const resourceType = selectedPrice && selectedPrice.resourceType ? selectedPrice.resourceType : 'ENERGY'
          if (!payload.resourceType) {
            delete (payload.resourceType)
          }

          console.log(111)
          if (resourceType === 'BANDWIDTH') {
            payload.bandwidthAmount = payload.energyAmount
            delete (payload.energyAmount)
          } else {
            delete (payload.bandwidthAmount)
          }

          if (!this.ordinary) {

            let enterprisePayKey = payload.enterprisePayKey
            delete (payload.enterprisePayKey)



            // let jsonData = '{ "receiveAddress": "TDWXDzPFFnq3yzohKr6CnTUytBfY87uztm", "energyAmount": 100, "unitPriceId": 12, "enterprisePayId": "tron_energy_11_delegate" }';
            // let payKey = "f6c6a4821044ac08831bb0403c4fef9e";
            payload.dataDigest = getDigest(JSON.stringify(payload), enterprisePayKey);


            console.log(payload, 'getDigest');
            console.log(enterprisePayKey, 'getDigest1');

          }
          orderCreate(payload).then(res => {
            console.log(res)
            this.enableEnterpriseBalance = res.enableEnterpriseBalance

            if (!res.enableEnterpriseBalance) {
              this.money = res.payTrxAmount;
            }
            this.getList()
            this.loading = false
            this.exchangeDialog = false
            this.tipsDialog = true;
            // let str =
            // this.$alert(str, this.$t('prompt'), {
            //   confirmButtonText: this.$t('confirm'),

            // });


          }).catch(error => {
            this.loading = false

          })


        } else {
          this.loading = false

          return false
        }
      })
    },

    getPrice(enterprisePayId) {
      if (enterprisePayId) {
        this.selectKey = true

      } else {
        this.selectKey = false

      }
      this.options = []
      unitPriceList(enterprisePayId).then(res => {
        console.log(res)
        let arr = []
        let resArr = res
        if(resArr.length==0){
          this.$message.error(this.$t('noEnterprisePrice'))
        }
        resArr.forEach(item => {
          console.log(item)
          item.unitChange = item.unit === 'Day' ? this.$t('day') : item.unit === 'Minute' ? this.$t('minute') : this.$t('hour')
          const isBandwidth = item.resourceType === 'BANDWIDTH'
          const amount = isBandwidth ? (item.currentBandwidth || item.bandwidth) : (item.currentEnergy || item.energy)
          const amountLabel = isBandwidth ? this.$t('bandwidth') : this.$t('energy')
          const price = isBandwidth ? (item.currentBandwidthPrice || item.bandwidthPrice) : (item.currentEnergyPrice || item.energyPrice)
          const isOverride = isBandwidth ? !!item.currentBandwidthPrice : !!item.currentEnergyPrice
          const suffix = isOverride ? ` (${this.$t('currentPriceEffective')})` : ''
          arr.push({
            id: item.id,
            resourceType: item.resourceType || 'ENERGY',
            label: `${this.$t('rent')}\u00A0${amount}\u00A0${amountLabel}/${item.num} ${item.unitChange}\u00A0,\u00A0${this.$t('only')}\u00A0${price}\u00A0TRX${suffix}`
          })
        })
        // \u00A0\u00A0
        this.options = arr;
        this.syncExchangeResourceTypeFromOptions()

      })
      if (enterprisePayId) {
        enterpriseBalance(enterprisePayId).then(res => {
          this.enterpriseBalance = res
        })
      }

    },
    getPriceWithLogin() {
      this.options = []
      listWithLogin().then(res => {
        let arr = []
        let resArr = res
        if(resArr.length==0){
          this.$message.error(this.$t('noEnterprisePrice'))
        }
        resArr.forEach(item => {
          console.log(item)
          item.unitChange = item.unit === 'Day' ? this.$t('day') : item.unit === 'Minute' ? this.$t('minute') : this.$t('hour')
          const isBandwidth = item.resourceType === 'BANDWIDTH'
          const amount = isBandwidth ? (item.currentBandwidth || item.bandwidth) : (item.currentEnergy || item.energy)
          const amountLabel = isBandwidth ? this.$t('bandwidth') : this.$t('energy')
          const price = isBandwidth ? (item.currentBandwidthPrice || item.bandwidthPrice) : (item.currentEnergyPrice || item.energyPrice)
          const isOverride = isBandwidth ? !!item.currentBandwidthPrice : !!item.currentEnergyPrice
          const suffix = isOverride ? ` (${this.$t('currentPriceEffective')})` : ''
          arr.push({
            id: item.id,
            resourceType: item.resourceType || 'ENERGY',
            label: `${this.$t('rent')}\u00A0${amount}\u00A0${amountLabel}/${item.num} ${item.unitChange}\u00A0,\u00A0${this.$t('only')}\u00A0${price}\u00A0TRX${suffix}`
          })
        })
        // \u00A0\u00A0
        this.options = arr;
        this.syncExchangeResourceTypeFromOptions()

      })

    },
    openExchange() {
      this.ordinary = true;

      this.formData = {
        receiveAddress: '',
        payAddress: '',
        energyAmount: null,
        unitPriceId: null,
        resourceType: 'ENERGY',

      }

      this.getPrice('');

      this.exchangeDialog = true;

      if (this.$route.query.hasOwnProperty('Referral')) {
        this.formData.referralCode = this.$route.query.Referral
      }
    },
    //将移动的关键代码移出
    moveMarquee() {
      // 获取内容区宽度
      var width1 = (document.getElementById('marquee1').getBoundingClientRect().width)
      var width2 = (document.getElementById('marquee2').getBoundingClientRect().width)
      //width为第二个span标签尾部到盒子尾部的距离，1200为外层盒子的宽度
      var width = width1 + width2 - 1200
      var marquee1 = document.getElementById("marquee1");
      var marquee2 = document.getElementById("marquee2");
      this.speed1 = this.speed1 - 1;
      this.speed2 -= 1;
      // 如果speed2的尾部移到盒子的尾部并且speed1的移动距离不超过文字的距离
      if (-this.speed2 >= width && -this.speed1 >= width1) {
        //让speed1重新在原位置移动
        this.speed1 = 1200;
      }
      if (-this.speed2 >= width1 + width2) {
        //如果speed2的尾部移动到盒子的头部，让speed2跟在speed1之后移动
        this.speed2 = 0
      }
      marquee1.style.transform = "translateX(" + this.speed1 + "px)";
      marquee2.style.transform = "translateX(" + this.speed2 + "px)";
    },
    runMarquee() {
      var marquee1 = document.getElementById("marquee1");
      var marquee2 = document.getElementById("marquee2");
      this.marqueeVar = setInterval(() => this.moveMarquee(), 30);
      //监听鼠标移入，清空定时器
      marquee1.addEventListener('mouseenter', () => {
        clearInterval(this.marqueeVar);
        this.marqueeVar = null
      })
      marquee2.addEventListener('mouseenter', () => {
        clearInterval(this.marqueeVar);
        this.marqueeVar = null
      })
      //监听鼠标移开，重启定时器
      marquee1.addEventListener('mouseleave', () => {
        this.marqueeVar = setInterval(() => this.moveMarquee(), 30);
      }
      )
      marquee2.addEventListener('mouseleave', () => {
        this.marqueeVar = setInterval(() => this.moveMarquee(), 30);
      }
      )
    },

    // 滚动监听器
    onScroll() {
      // 获取浏览器窗口高度
      let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // 获取当前文档流的 scrollTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 屏幕垂直中线
      let screenMiddle = scrollTop + clientHeight / 2;
      this.menu.forEach(item => {
        //以浏览器窗口垂直中线为准，中线在内容模块的上边界至下边界之间，导航栏都认为在该楼层
        if (screenMiddle - item.offsetTop >= 0 && screenMiddle - item.offsetTop < item.scrollHeight) {
          item.active = 1;
        } else {
          item.active = 0;
        }
      })
    },
    // 跳转到指定索引的元素
    scrollTo(item) {
      if (item.id === 'cangchu') {
        this.drawer = false
        this.dialogVisible = true
      }
      // 获取目标��� offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始���所���� +1
      const targetOffsetTop = document.getElementById(item.id).offsetTop - 70
      // 获取当前 offsetTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素������字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          requestAnimationFrame(smoothUp)
        }
      }
    },
    handleAddressSelect(row) {
      this.address = row.address
      this.addressSelectVisible = false
    },
    openAddressSelect(type) {
      this.addressSelectType = type
      this.addressSelectVisible = true
      this.getAddressList()
    },
    // 获取地址列表
    async getAddressList() {
      try {
        const res = await getAddressList()
        this.addressList = res || []
      } catch (error) {
        console.error('获取地址列表失败:', error)
      }
    },

    // 添加地址
    async handleAddAddress() {
      try {
        this.$refs.addressForm.validate(async valid => {
          if (valid) {
            await createAddress({
              address: this.addressForm.address
            })
            this.$message.success(this.$t('addSuccess'))
            this.addressForm.address = ''
            this.getAddressList()
          }
        })
      } catch (error) {
        console.error('添加地址失败:', error)
      }
    },

    // 删除地址
    async handleDeleteAddress(row) {
      try {
        await this.$confirm(this.$t('confirmDelete'), this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        })
        await deleteAddress(row.id)
        this.$message.success(this.$t('deleteSuccess'))
        this.getAddressList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除地址失败:', error)
        }
      }
    },

    // 打开地址选择
    openAddressSelect(type) {
      this.addressSelectType = type
      this.addressSelectVisible = true
      this.getAddressList()
    },

    // 处理地址选择
    handleAddressSelect(row) {
      if (this.addressSelectType === 'receive') {
        this.formData.receiveAddress = row.address
      } else if (this.addressSelectType === 'pay') {
        this.formData.payAddress = row.address
      }
      this.addressSelectVisible = false
    },
    onMonitorResourceTypeChange() {
      this.monitorAddressForm.unitPriceId = null
      if (this.monitorAddressForm.resourceType === 'BANDWIDTH') {
        this.monitorAddressForm.energyThreshold = null
        this.monitorAddressForm.energyAmount = null
      } else {
        this.monitorAddressForm.bandwidthThreshold = null
        this.monitorAddressForm.bandwidthAmount = null
      }
    },
    monitorPriceOptions() {
      const selectedType = this.monitorAddressForm.resourceType || 'ENERGY'
      return this.options.filter(item => (item.resourceType || 'ENERGY') === selectedType)
    },
    getMonitorResourceTypeLabel(resourceType) {
      return resourceType === 'BANDWIDTH' ? this.$t('bandwidth') : this.$t('energy')
    },
    getMonitorThresholdValue(row) {
      const resourceType = row && row.resourceType ? row.resourceType : 'ENERGY'
      return resourceType === 'BANDWIDTH' ? row.bandwidthThreshold : row.energyThreshold
    },
    getMonitorAmountValue(row) {
      const resourceType = row && row.resourceType ? row.resourceType : 'ENERGY'
      return resourceType === 'BANDWIDTH' ? row.bandwidthAmount : row.energyAmount
    },
    // 获取监控地址列表
    async getMonitorAddressList() {
      try {
        const res = await getMonitorAddressList()
        this.monitorAddressList = (res || []).map(item => ({
          ...item,
          resourceType: item.resourceType || 'ENERGY'
        }))
      } catch (error) {
        console.error('获取监控地址列表失败:', error)
      }
    },
    // 添加监控地址
    async handleAddMonitorAddress() {
      try {
        this.$refs.monitorAddressForm.validate(async valid => {
          if (valid) {
            try {
              await createMonitorAddress({
                address: this.monitorAddressForm.address,
                energyThreshold: this.monitorAddressForm.energyThreshold,
                bandwidthThreshold: this.monitorAddressForm.bandwidthThreshold,
                unitPriceId: this.monitorAddressForm.unitPriceId,
                energyAmount: this.monitorAddressForm.energyAmount,
                bandwidthAmount: this.monitorAddressForm.bandwidthAmount,
                resourceType: this.monitorAddressForm.resourceType
              })
              this.$message.success(this.$t('addSuccess'))
              this.getMonitorAddressList()
              // 重置表单
              this.monitorAddressForm = {
                address: '',
                resourceType: 'ENERGY',
                energyThreshold: null,
                bandwidthThreshold: null,
                unitPriceId: null,
                energyAmount: null,
                bandwidthAmount: null
              }
              this.$refs.monitorAddressForm.resetFields()
            } catch (error) {
              console.error('添加监控地址失败:', error)
              // 这里不再弹窗，交由axiosFun.js统一处理
            }
          }
        })
      } catch (error) {
        console.error('表单验证失败:', error)
      }
    },
    // 删除监控地址
    async handleDeleteMonitorAddress(row) {
      try {
        await this.$confirm(this.$t('confirmDelete'), this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        })
        await deleteMonitorAddress(row.id)
        this.$message.success(this.$t('deleteSuccess'))
        this.getMonitorAddressList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除监控地址失败:', error)
        }
      }
    },
    getUnitPriceName(unitPriceId) {
      const unitPrice = this.options.find(item => item.id === unitPriceId);
      return unitPrice ? unitPrice.label : '';
    },
    handleIntervalChange(value) {
      // 当选择"从不"时，自动将余额阈值设置为-1
      if (value === 0) {
        this.notificationSettings.balance_notify = -1;
      } else if (this.notificationSettings.balance_notify === -1) {
        // 当从"从不"切换到其他选项时，清空余额阈值
        this.notificationSettings.balance_notify = null;
      }
    },
    saveNotificationSettings() {
      this.loadingNotification = true;
      this.$refs.notificationForm.validate(async valid => {
        if (valid) {
          try {
            await updateBalanceNotify({
              balanceNotify: this.notificationSettings.balance_notify,
              balanceNotifyInterval: this.notificationSettings.balance_notify_interval
            })
            this.$message.success(this.$t('saveSuccess'))
            this.personalInfoDialog = false
          } catch (error) {
            console.error(this.$t('saveFailed'), error)
          } finally {
            this.loadingNotification = false;
          }
        } else {
          this.loadingNotification = false;
        }
      })
    },
    // 刷新账户余额
    async refreshBalance() {
      this.refreshingBalance = true
      try {
        const res = await getUserInfo()
        this.userData.balance = res.balance
        this.$message.success(this.$t('refreshSuccess'))
      } catch (error) {
        console.error('刷新余额失败:', error)
        this.$message.error(this.$t('refreshFailed'))
      } finally {
        this.refreshingBalance = false
      }
    },
    // 打开监听间隔设置弹窗
    async openMonitorIntervalDialog() {
      this.monitorIntervalVisible = true
      // 从用户信息接口获取当前的监听间隔设置
      try {
        const res = await getUserInfo()
        this.monitorIntervalForm.monitorNotifyInterval = res.monitorNotifyInterval || 0
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 如果获取失败，设置默认值
        this.monitorIntervalForm.monitorNotifyInterval = 0
      }
    },
    // 保存监听间隔设置
    saveMonitorInterval() {
      this.loadingMonitorInterval = true;
      this.$refs.monitorIntervalForm.validate(async valid => {
        if (valid) {
          try {
            await updateMonitorNotifyInterval({
              monitorNotifyInterval: this.monitorIntervalForm.monitorNotifyInterval
            })
            this.$message.success(this.$t('saveSuccess'))
            this.monitorIntervalVisible = false
          } catch (error) {
            console.error(this.$t('saveFailed'), error)
          } finally {
            this.loadingMonitorInterval = false;
          }
        } else {
          this.loadingMonitorInterval = false;
        }
      })
    }
  }
}
</script>
<style>
#staging_m .numsP .el-input__inner {
  width: 30vw;
  height: 7.5vw !important;
  line-height: 7.5vw !important;
  margin: 0 2vw;
}

#staging_m .el-drawer__body {
  margin: 0 auto;
  padding: 0 !important;
  width: 100%;
  text-align: center;
}

#staging_m .el-dropdown-selfdefine {
  display: flex;
  align-items: center;
  justify-content: center;
}

#staging_m .el-dropdown {
  /* width: 100%; */
}

#staging_m .el-drawer {
  background: linear-gradient(to bottom, #6c4860, #f1dcf0);
}

#staging_m {
  font-size: 4vw;
}

#staging_m .formDiv .el-input__inner {
  height: 10vw;
  line-height: 10vw;
}

#staging_m .formDiv .el-form-item__label {
  text-align: left;
  font-weight: 550;
  font-size: 4vw;
  color: #333;
}

#staging_m .formDiv .el-form-item__content {
  margin-left: 0 !important;
}

#staging_m .cancel:hover {
  border: 1px solid #31545D;
  color: #31545D;
  background: white;
}

#staging_m .tTable td.el-table__cell,
#staging_m .el-table th.el-table__cell.is-leaf {
  border-bottom: unset;
}

#staging_m .el-dialog {
  padding: 4.5vw;
  border-radius: 3vw;


  background: linear-gradient(to bottom, #819096, #f7f7f8);
}

#staging_m .el-dialog__header {
  padding: 0 4.5vw 4.5vw;

}

#staging_m .el-dialog__body {
  padding: 7.5vw 4.5vw 4.5vw;

}

#staging_m .el-dialog__footer {
  margin-top: 2.5vw;
  padding: 6vw 4.5vw 2.5vw;
  /* background: #f7f7f8; */
}

#staging_m {
  /* height: 100vh;
  overflow: auto; */
  min-width: 100vw;
}

#staging_m .el-select {
  width: 100%;
}

#staging_m .tTable thead tr {
  /* background-color: #734a65!important; */
}

#staging_m .tTable th.el-table__cell {
  /* background-color: rgba(115, 74, 101, 0.9) !important; */
  background-color: rgba(49, 83, 95,.9) !important;

  color: #f1f1f1;
}

#staging_m .tTable tr:nth-child(2n) {
  background-color: rgba(49, 83, 95,.9) !important;

}

#staging_m .tTable tr {
  background-color: rgba(49, 83, 95,.9) !important;

}

#staging_m .tTable tbody tr:hover>td {
  background-color: unset !important;
}

#staging_m .tTable::before {
  background-color: unset !important;
}

#staging_m .tTable td.el-table__cell {
  border-bottom: unset !important;
}

#staging_m .tTable .cell {
  color: #fff;
}

#staging_m .el-button--primary {
  background-color: #31545D !important;
  border: 1px solid #31545D !important;
}

#staging_m .el-drawer__header {
  color: white !important;
  display: none;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.dialog-title{
  font-size: 3.2vw;
}
.info-box{
  width: 100%;

}
.info-box div{
  line-height: 6.5vw;
  overflow: hidden;
  margin-bottom: 2vw

}
.info-box .info1{
  width: 100%;
  display: inline-block;
  text-align: left;
  font-size:3.5vw;
  overflow: hidden;
  color: #333;
  font-weight: bold;
}
.info-box .info2{
  display: block;
  height: 8.5vw;
  line-height: 6.5vw;
  overflow: hidden;
  color: #666;

  width: 100vw;

  font-size: 3.5vw;
  position: relative;
  .xing{
    position: absolute;
    width: 70vw;
  }
  .eye{
    position: absolute;
    width: 4vw;
    margin-top: 1vw;
    left: 67vw!important;
    cursor: pointer;
  }

  /* text-align: right; */
}

.register {
  height: 35px;
  margin-top: 18px;

}

.register span {
  color: #31545D;
  margin-left: 8px;
  cursor: pointer;

}

.loginAcc {
  margin-top: 4vw;
  margin-left: 3vw;
}

.userItem {
  display: flex;
}

.userBox p {
  color: #f3f3f3;
  display: flex
}

.changeUserBox {
  float: right;
  margin-right: 2vw;
  width: auto !important;
  margin-top: -1vw;
}

.changeUser {
  color: #31545D;
  font-size: 2.5vw;
  cursor: pointer;
  line-height: 6.5vw;
  padding: 0 2vw;
  border: 1px solid #31545D;
  border-radius: 2.4vw;
}

.transTips .tranSpan {
  color: #666;
  font-weight: 600;
  font-size: 3.5vw;
  /* display: block; */
  width: auto;
  overflow: hidden;
}

.tranSpan1 {
  /* display: block; */
  margin-left: 2vw;
}

.transTips {
  font-size: 3.5vw;
  color: #31545D;
  line-height: 8vw;
  word-break: break-word;
  /* margin-bottom: 3vw; */
}

.dP {
  text-align: center;
  color: #333;
  font-size: 3.5vw;
  line-height: 8vw;
  font-weight: 500;
}

.dAddress {
  color: #67c23a;
  font-size: 3.5vw;
  font-weight: 550;
  word-break: break-word;
}

.money {
  font-size: 3.5vw;
  font-weight: 550;
  color: #31545D;
}

.nums {
  margin-top: 3vw;
}

/* .nums span {
  display: inline-block;
  width: auto;
  padding: 0px 1.5vw;
  border-radius: 1.5vw;
  cursor: pointer;
  overflow: hidden;
  margin-right: 2.5vw;
  line-height: 7vw;
  font-size: 3.5vw;
  border: 1px solid #dcdfe6;
} */

.numsP {
  /* display: flex; */
  /* float: right; */
  width: 100%;
  line-height: 7.5vw;
}

.numsP div {
  width: 33vw;
}

.numsSpan {
  display: inline-block;
  width: auto;
  padding: 0px 1vw;
  border-radius: 1vw;
  cursor: pointer;
  overflow: hidden;
  margin-right: 2.5vw;
  line-height: 7vw;
  font-size: 3.25vw;
  border: 1px solid #dcdfe6;
}

.presetLabel {
  color: #909399;
  font-size: 2.8vw;
  margin-left: 1vw;
}

.footDiv {
  background: #31545D;
  text-align: center;
  padding: 5vw;
  color: #fff;
  margin-top: 6vw;
}

.tTable {
  margin-top: 15vw;
}

.tDiv h3 {
  color: #fff;
  font-size: 7vw;
  text-align: center;
}

.tDiv {
  /* background: #6c4860; */
  /* background: linear-gradient(to bottom, #6c4860, #f1dcf0); */
  background: linear-gradient(to bottom, #0E2831, rgba(49, 83, 95,.4));

  padding: 6vw 3vw 6vw;
  overflow: hidden;
}

.searchButton {
  background-color: #31545D;
  border-color: #31545D;
}
.searchButton1{
  background-color: #31545D;
  border-color: #31545D;
  position: absolute;
  top: 0;
   right: 0;
   padding: 0 2vw!important;
   line-height: 7.5vw!important;
height: 7.5vw!important;
}

.qrcode {
  width: 37.5vw;
  height: 37.5vw;
}
.qrcodePaid {
  width: 30vw;
  height: 30vw;
}

.kfSpan {
  display: block;
  margin: 2.5vw 0;
  text-align: center;
  font-size: 4.5vw;
  color: #333;
}

.kfP {
  width: 15vw;
  height: 15vw;
}

.kfDiv .copy_white {
  width: 4vw;
  position: absolute;
  left: 5vw;
  top: 2.5vw;
}

.kfDiv {
  margin: 0;
  text-align: center;
}

.kfDiv .el-button {
  padding-left: 7.5vw;
  position: relative;
  text-indent: 2.5vw;
  display: block;
  border: 0;
  background: #31545D;
  width: 35vw;
  height: 10vw;
  border-radius: 2vw;
  margin: 0 auto;
  margin-top: 6vw;
}

.el-button {
  border-radius: 1.5vw;
}

.kfH3 {
  padding-bottom: 7vw;
  font-size: 4.5vw;
  text-align: center;
  color: #333;
  font-weight: 500;
}

.tlLi img {
  /* width: 6vw; */
  height: 3vw;
  margin-right: 1.5vw;
}

.tlLi {
  float: left;
  align-items: center;
  justify-items: center;
  margin-bottom: 5vw;
  display: flex;
  justify-content: left;
  font-size: 4vw;
  color: #777a9c;
}

.tlUl {
  /* width: 250vw; */
  margin: 12.5vw auto;
}

.intro {
  font-size: 4.2vw;
  color: #777a9c;
  line-height: 1.8;
  margin: 15vw auto auto;
  text-align: justify;
}

.tlSpan {
  margin: 7.5vw auto auto;
  font-size: 4.5vw;
  color: #53556c;
}

.tlP1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15vw;
  height: 15vw;
  margin: auto;
}

.tlP {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 30vw;
}

.tlDiv {
  margin: auto;
  display: flex;
  width: 90vw;
  justify-content: space-between;
}

.tlH3 {
  margin: 10vw 0;
  font-size: 7vw;
  text-align: center;
  font-weight: 500;
}

.tlDivAll {
  width: 90vw;
  margin: 0 auto;
}

#tielu {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding-bottom: 12.5vw;
  background: #f8f8f8;
}

.ccPDiv {
  display: flex;
  margin-bottom: 4vw;
}

.ccP img {
  width: 8vw;
  height: 8vw;
  margin-top: 3.5vw;
}

.ccP {
  text-align: center;
  width: 15vw;
  /* color: #692dd8; */
  background: #f1f1f1;
  height: 15vw;
  border-radius: 50%;
}

.ccH4 {
  color: #35364b;
  font-size: 4vw;
  display: flex;
  align-items: center;
  margin-left: 3vw;
  width: calc(100% - 18vw);
  /* margin: 7.5vw 0 5vw; */
  font-weight: 500;
}

.ccSpan {
  color: #53556c;
  font-size: 4.5vw;
  line-height: 1.8;
}

.ccLi:hover {
  box-shadow: 0 1.5vw 8vw #1718201a;
  border-bottom-color: #31545D;
}

/* .ccLi:nth-child(2n) {
  margin-left: 20vw;
} */
.ccLi {
  width: 90vw;

  border-bottom: 8px solid rgba(49, 84, 93, 0.38);

  transition: all 0.4s;
  border-radius: 2.5vw;
  position: relative;
  box-sizing: border-box;
  cursor: default;
  overflow: hidden;
  background: #ffffff;
  padding: 4vw;
  margin: 0 auto 6vw;
}

.main {
  background-color: #f5f5f5;
}

#shuilu {
  width: 100vw;
  min-width: 100vw;
  height: auto;
  overflow: hidden;
  margin: 6vw auto 0;
}

#shuilu h3 {
  margin: 10vw 0;
  font-size: 7vw;
  font-weight: 500;
  text-align: center;
}

.trans strong {
  font-size: 4.5vw;
}

.trans {
  margin-top: 6vw;
}

.title2 span {
  display: inline-block;
  background: #692dd8;
  width: 7.5vw;
  height: 7.5vw;
  line-height: 7.5vw;
  text-align: center;
  border-radius: 1vw;
  color: white;
  margin-right: 1vw;
  font-weight: 700;
}

.title2 {
  font-size: 4.5vw;
  color: #fff;
  color: #333;
}

.ul-box li {
  font-size: 4.2vw;
  line-height: 1.5;
  color: #777a9c;
  text-align: justify;
  display: list-item;
  list-style: initial;
  list-style-type: disc;
  padding-bottom: 4vw;
}

.ul-box {
  margin-top: 3vw;
  list-style: initial;
  padding: 2.5vw 0 0 5vw;
}

.energyExchange {
  /* position: absolute; */
  margin-top: 5vw;
  float: right;
  background-color: rgb(51, 84, 93) !important;
  border: none;
}

#num2 {
  font-size: 3.5vw;
  color: #777a9c;
  font-weight: 500;
  position: relative;
}

.num1 img {
  float: right;
  /* margin-top: 3vw; */
  position: absolute;
  top: 3vw;
  right: 1vw;
  width: 5vw;
  cursor: pointer;
  font-weight: 700;
}

.num1 {
  background: #e7e6e6;
  height: 10.5vw;
  width: 100%;
  box-sizing: border-box;
  padding: 0 4vw;
  align-items: center;
  border-radius: 1vw;
  line-height: 10.5vw;
  font-size: 5.5vw;
  font-weight: 700;
  color: #31545D;
}

.title3 img {
  width: 5.5vw;
  height: 5.5vw;
  margin-left: 1vw;
  margin-top: 0.5vw;
  cursor: pointer;
  position: absolute;
}

.title3 {
  display: block;
  color: #53556c;
  font-size: 4.5vw;
  margin-bottom: 5vw;
}

.exchangeItem {
  padding: 3vw;
  box-sizing: border-box;
  height: auto;
  overflow: hidden;
}

.exchangeDiv {
  /* display: flex;
  justify-content: start; */
  position: relative;

  width: 100vw;
  min-width: 100vw;
  height: auto;
  box-sizing: border-box;
  margin: 3vw auto 0;
  /* background: rgba(248, 248, 248, 0.95); */

  box-shadow: 0 1.5vw 6vw #1718201a;
  /* border-radius: 10px; */
  overflow: hidden;
  margin-bottom: 5vw;
  padding: 6vw 3vw 6vw;
  box-sizing: border-box;
}

.dibu2-all {
  padding: 0 6vw;
  width: 100vw;
  min-width: 100vw;
  height: 13vw;
  font-size: 5vw;
  box-sizing: border-box;
  background: #ffffffb2;
  line-height: 13vw;
  white-space: nowrap;
  margin: 0 auto;
}

.dibu2 {
  width: 100%;
  overflow: hidden;
  color: #333;
}

#marquee1 span,
#marquee2 span {
  margin-right: 9vw;
}

#marquee1 {
  display: inline-block;
}

#marquee2 {
  display: inline-block;
}

.maintitle1 {
  height: 40vw;
  color: #fff;
  text-align: center;
}

.maintitle1 h4 {
  font-size: 5vw;
  padding-top: 5vw;
}

.title1 {
  font-size: 8vw;
  color: white;
  padding-top: 10vw;
}

.gongluBg {
  width: 100%;
  position: absolute;
  z-index: 0;
  height: auto;
  /* height: 300px; */
  left: 0;
  top: 0;
}

.gongluContent {
  position: relative;
}

#gonglu {
  position: relative;
  min-height: 350px;
  /* height: 27px; */
  /* background-image: url(../assets/img/bg.jpg); */
  /* background-size: cover; */
  width: calc(100vw + 1px);
  margin-left: -1px;
  overflow: hidden;
  height: auto;
}

.content-all {
  margin-top: 13vw;
}

.main {}

.content {
  /* margin-bottom: 60px; */
}

.header {
  padding: 4vw;
  font-size: 5vw;
  font-weight: 600;
  color: black;
}

.sidebar-all {
  width: 100%;
  z-index: 9;
  height: 13vw;
  background-color: #000;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0 3vw;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.Switchlanguage {
  color: #d1d1d1;
  font-size: 3vw;
  margin-left: 1vw;
}

.global {
  /* position: absolute; */
  width: 5vw;
  height: 5vw;
  /* top: 4px; */
}

.sidebar {
  height: 100%;
  width: 100%;
  /* display: flex; */
  /* justify-content: space-around; */
}

.sidebar li {
  /* padding: 0 24px; */
  /* line-height: 15vw; */
  height: 15vw;
  width: 35vw;
  margin: 6vw auto 0;
  text-align: center;
  list-style: none;
}

.sidebar .active {
  color: #f1f1f1 !important;
  border-bottom: 3px solid #f1f1f1;
}

.lang {
  max-width: 88%;
  width: auto;
  line-height: 12vw;
  height: 12vw;
  border: 1px solid #b8b5d8;
  border-radius: 6vw;
  /* padding: 0 1vw; */
  margin: 5vw auto 0;
  overflow: hidden;
  /* display: flex; */
}

.openMenu {
  font-size: 6vw;
  color: #ffffffd7;
}

.logo1 {
  height: auto;
  width: 38vw;
  margin: 8vw auto 0;
}

.logo {
  /* width: 136px; */
  height: 6vw;
  margin-top: 3.5vw;
  /* border-radius: 20px; */

  background-size: cover;
}

/* .sidebar li a span {
  margin-left: 28px;
} */
.sidebar li a img {
  width: 4.5vw;
  height: 4.5vw;
  position: absolute;
  top: 3.5vw;
  margin-left: -6.5vw;
}

.sidebar li a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 4vw;
  /* color: #fff; */
  color: white;
  position: relative;

  text-decoration: none;
}

.address-book {
  padding: 0 20px;
}

.el-icon,
.el-icon-close,
* /deep/ .el-dialog__close {
    color: #fff !important;
}
</style>




// WEBPACK FOOTER //
// src/views/mobileStaging.vue